import Tooltip from '@amzn/meridian/tooltip';
import React, { ReactNode } from 'react';
import { TranslatedString } from './localization';
import ExternalLink from './localization/ExternalLink';

export const OptionalExternalLink = ({
    href,
    tooltip,
    children,
}: {
    href?: string | null;
    tooltip?: string;
    children: ReactNode;
}) => {
    if (!href) return <>{children}</>;

    const link = (
        <ExternalLink href={href} target={'_blank'}>
            {children as TranslatedString}
        </ExternalLink>
    );

    return tooltip ? (
        <Tooltip position={'top'} title={tooltip}>
            {link}
        </Tooltip>
    ) : (
        link
    );
};
